import _ from 'lodash'
import {getDqParamsObject} from 'module/CustomField/util/DqParam'
import CacheCollection from 'collection/CacheCollection'
import axios from 'axios'
import {log} from 'common/log'
import {CFValiTO} from 'generated/JavaTO'
import {FieldError} from 'module/CustomField/type/FieldError'

let cfValiPromise: null | Promise<CFValiTO[]> = null;
const getCFValiPromise = () => {
	if (!cfValiPromise) {
		cfValiPromise = axios.get<CFValiTO[]>('../json/cfvali/all').then(resp => resp.data);
	}
	return cfValiPromise;
};

// force init after 8s
setTimeout(() => getCFValiPromise(), 8 * 1000);

const cache = new CacheCollection<Promise<undefined | FieldError>>();

export function validateRemoteCFVali(field: number, cfValiId: number, model: any): Promise<undefined | FieldError> {
	return getCFValiPromise().then((cfValiList) => {
		const cfVali = _.find(cfValiList, {id: cfValiId});
		if (!cfVali) {
			log.error(`Validation rule missing (id = ${cfValiId}, field = ${field})`);
			return {field, message: "Validation rule not found"};
		}
		const {id, dqParams, cacheTTL} = cfVali;
		const clientParams = getDqParamsObject(dqParams, model);
		const requestIdPath = [id, JSON.stringify(clientParams)];
		let data = cache.getCache(requestIdPath);
		if (!data) {
			data = axios.post<Promise<undefined | FieldError>>(`../json/cfvali/${encodeURIComponent(id)}`, clientParams)
				.then(() => undefined) //ok
				.catch((err) => ({field, message: err.response.data && err.response.data.message})); //failed
			cache.setCache(requestIdPath, data, cacheTTL);
		}
		return data;
	})
}